import React, { Fragment } from 'react';
import useScrollCapture from './use-scroll-capture';
import useScrollLock from './use-scroll-lock';
var blurSelectInput = function blurSelectInput(event) {
  var element = event.target;
  return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
export default function ScrollManager(_ref) {
  var children = _ref.children,
    lockEnabled = _ref.lockEnabled,
    _ref$captureEnabled = _ref.captureEnabled,
    captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled,
    onBottomArrive = _ref.onBottomArrive,
    onBottomLeave = _ref.onBottomLeave,
    onTopArrive = _ref.onTopArrive,
    onTopLeave = _ref.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive: onBottomArrive,
    onBottomLeave: onBottomLeave,
    onTopArrive: onTopArrive,
    onTopLeave: onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });
  var targetRef = function targetRef(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };
  return /*#__PURE__*/React.createElement(Fragment, null, lockEnabled &&
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
  React.createElement("div", {
    onClick: blurSelectInput,
    style: {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
      position: 'fixed',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
      insetBlockEnd: 0,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
      insetBlockStart: 0,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
      insetInlineEnd: 0,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
      insetInlineStart: 0
    }
  }), children(targetRef));
}